import type { ReactNode } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { useWhoami } from '@/hooks/useWhoami';
import { LandingView } from './LandingView';

// Gates the app behind the auth (whoami) query so unauthenticated users — and
// everyone during the initial silent NAA token acquisition — see the branded
// landing instead of a half-loaded tree or a per-query error.
//
// This renders INSTEAD of TaskPaneShell while loading/erroring, and the shell
// owns the 100vh height, so the gate must establish the full-height context
// itself — otherwise LandingView (height:100%) collapses and its vertical
// centering breaks.
const useStyles = makeStyles({
  fill: { height: '100vh' },
});

export function AuthGate({ children }: { children: ReactNode }) {
  const styles = useStyles();
  const { isPending, isError, error, refetch } = useWhoami();

  if (isPending) {
    return (
      <div className={styles.fill}>
        <LandingView state="loading" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className={styles.fill}>
        <LandingView
          state="error"
          onRetry={() => {
            void refetch();
          }}
          errorMessage={error instanceof Error ? error.message : undefined}
        />
      </div>
    );
  }

  return <>{children}</>;
}
